import Button from '../../atoms/Button/Button';
import React, { Component } from 'react';

import './styles.css';
import SectionHeading from '../../../components/molecules/SectionHeading/SectionHeading';

/**
 * Description
 *
 * @typedef {Object} Props
 * @prop {Object} content
 *
 * @augments {Component<Props>}
 */
export default class FreeTrial extends Component {
	render () {
		const { heading, subheading, paymentNotAvailable } =
			this.props.content.freeTrial;
		const { bannerHeading, paragraphs, buttonText, buttonHref } =
			this.props.content.freeTrial.banner;

		return (
			<div className='FreeTrialContainer'>
				<SectionHeading heading={heading} subheading={subheading} />
				{paymentNotAvailable && <p className='paymentNotAvailable'>{paymentNotAvailable}</p>}
				<div className='FreeTrialContent'>
					<h1>{bannerHeading}</h1>
					{paragraphs.map((text) => (
						<p key={text} className='trialInfoText'>
							{text}
						</p>
					))}
					<div className='trialButtonWrapper'>
						<Button href={buttonHref} className='trialButton'>
							{buttonText}
						</Button>
					</div>
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/templates/FreeTrial/FreeTrial.js